export const getWorkout = (workouts: Workout[], id: number) => {
  const workout = workouts.find((v) => v.id === id);

  if (workout) {
    return workout;
  }

  return null;
};
